function activateSelectBoxIt(el) {
  const $el = $(el);

  $el.find("option").first().remove();

  $el.selectBoxIt({
    autoWidth: false,
    downArrowIcon: '',
    dynamicPositioning: false
  });

  $el.each(function() {
    togglePlaceholder(this);
  });
}

function togglePlaceholder(el) {
  const selectBoxTextID = '#' + el.getAttribute('id') + 'SelectBoxItText';
  const selectBoxText= $(selectBoxTextID);

  selectBoxText.toggleClass('placeholder', el.value.length === 0);
}

export default activateSelectBoxIt;
